import styled from "styled-components";
import { Empty } from "antd-mobile";
import { fmoney,block2date} from "../../../../utils/utils";
import { Loading } from "react-vant";
import { useIntl } from "react-intl";

export default function Record({ list, loading = false, onClick = () => {} }) {
  const intl = useIntl()
  
  return (
    <>
      {loading ? (
        <Loading style={{ marginTop: "20vw" }} size="2.4rem" vertical>
         {intl.formatMessage({id:'common.loading',defaultMessage:'加載中...'})}
        </Loading>
      ) : list && list.length > 0 ? (
        <RecordsWrapper>
          {list.map((e, i) => (
            <RecordWrapper
              key={i}
              onClick={() => {
                onClick(e);
              }}
            >
              <FlexDiv style={{ marginBottom: "1.0rem" }}>
                <span style={{ color: "#9c9393" }}>
                  {block2date(e.day)}
              
                </span>
                <span style={{ color: !e.status ? "#FF5C00" : "#969696" }}>
                  {!e.status ? "未領獎" : "已領獎"}
                </span>
              </FlexDiv>
              <FlexDiv>
                <Item>
                  <img src="/image/RB.png" alt={""} />
                  <span style={{ marginLeft: "1.0rem", verticalAlign: "top" }}>
                    {fmoney(e.rb, 2)}
                  </span>
                </Item>
                <Item>
                  <img src="/image/quility_chip.png" alt={""} />
                  <span style={{ marginLeft: "1.0rem", verticalAlign: "top" }}>
                    {fmoney(e.rbct, 2)}
                  </span>
                </Item>
                <Item>
                  <img src={"/image/equip_chip.png"} alt={""} />
                  <span style={{ marginLeft: "1.0rem", verticalAlign: "top" }}>
                  {fmoney(e.rbct, 2)}
                  </span>
                </Item>
              </FlexDiv>
            </RecordWrapper>
          ))}
        </RecordsWrapper>
      ) : (
        <Empty description={
          intl.formatMessage({id:'common.no_data',defaultMessage:'暫無數據'})
        } />
      )}
    </>
  );
}

const RecordsWrapper = styled.div`
  border: 2px solid #000;
  border-radius: 2.2rem;
  box-shadow: 2px .25rem .0rem #000;
  /* padding-bottom: 3.0rem; */
`;

const RecordWrapper = styled.div`
  padding: .8rem 1.7rem;
  border-bottom: 1px solid #000;
  overflow: hidden;
  // display: flex;
  // justify-content: space-between;
  // font-weight: bold;
  &:last-child {
    border: none;
  }
  /* &:first-child {
    border-bottom: 1px solid #000;
  } */
`;

const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    width: 2.6rem;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
`;
